module.exports = __webpack_public_path__ + "img/ki.svg";